import createIcon from '../../createIcon';

/**
 * @component @name HdrAuto
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMDQgOC4wNEgxMS45NUwxMC4zNSAxMi41OUgxMy42NEwxMi4wNCA4LjA0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyIDJDNi40OCAyIDIgNi40OCAyIDEyQzIgMTcuNTIgNi40OCAyMiAxMiAyMkMxNy41MiAyMiAyMiAxNy41MiAyMiAxMkMyMiA2LjQ4IDE3LjUyIDIgMTIgMlpNMTUuMjEgMTdMMTQuMjMgMTQuMTlIOS43OEw4Ljc4IDE3SDYuODhMMTEuMDEgNkgxMi45OEwxNy4xMSAxN0gxNS4yMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HdrAuto = createIcon('HdrAuto', [
  ['path', { d: 'M12.04 8.04H11.95L10.35 12.59H13.64L12.04 8.04Z', key: 'adqfhz' }],
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM15.21 17L14.23 14.19H9.78L8.78 17H6.88L11.01 6H12.98L17.11 17H15.21Z',
      key: 'si2plq',
    },
  ],
]);

export default HdrAuto;
